<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Aufgang</h3>
<p class="vers">Der Sonnenborn im Osten quillt<br class="calibre2"/>
sein blutig Wasser in die Nacht.<br class="calibre2"/>
Zum weiten Himmelsbecken schwillt<br class="calibre2"/>
es an in namenloser Pracht,<br class="calibre2"/>
bis endlich aus der Feuerflut<br class="calibre2"/>
die Nymphe steigt in Liebesglut,<br class="calibre2"/>
vor der entweicht die schwarze Nacht,<br class="calibre2"/>
die Weltenpulse hüpfen macht,<br class="calibre2"/>
all ihre Glut und Liebeslust<br class="calibre2"/>
ausströmet in der Erde Brust.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0012.vue?4597ed16